(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"), require("THREE"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM", "THREE"], factory);
	else if(typeof exports === 'object')
		exports["MiniMe"] = factory(require("React"), require("ReactDOM"), require("THREE"));
	else
		root["MiniMe"] = factory(root["React"], root["ReactDOM"], root["THREE"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__94__, __WEBPACK_EXTERNAL_MODULE__174__) {
return 